import { Device, DeviceHwID } from '../types/models'
import { DevicePanel } from './DevicePanel'

export interface DeviceDataTableProps {
  devices: Device[]
  link?: string
}

export function DeviceDataTable(props: DeviceDataTableProps): React.ReactElement {

  const { devices, link } = props

  const masters: Device[] = []
  const slaves: Record<DeviceHwID, Device[]> = {}

  devices.forEach(device => {
    if (device.values?.slave_of) {
      slaves[device.values?.slave_of] = slaves[device.values?.slave_of] || []
      slaves[device.values?.slave_of].push(device)
    } else {
      masters.push(device)
    }
  })

  const rendering: React.ReactElement[] = []

  masters.forEach(device => {

    const pending = device.ports?.map(p => p.config.pending).filter(p => !!p && (p instanceof Object)).map(p => Object.keys(p as Object).length).reduce((prev, cur) => cur + prev, 0) || 0

    rendering.push(
      <DevicePanel
        className={pending > 0 ? 'pending' : 'ready'}
        key={device.id}
        device={device}
        url={link?.replace(':id', `${device.id}`)}
      />
    )

    if (slaves[device.hw_id]) {
      slaves[device.hw_id].forEach(slave => {
        rendering.push(
          <DevicePanel
            key={slave.id}
            device={slave}
            url={link?.replace(':id', `${slave.id}`)}
          />
        )
      })
      delete slaves[device.hw_id]
    }
  })

  // Just in case of some screw up.
  Object.keys(slaves).forEach(hwId => {
    slaves[hwId as DeviceHwID].forEach(slave => {
      rendering.push(
        <DevicePanel
          key={slave.id}
          device={slave}
          url={link?.replace(':id', `${slave.id}`)}
        />
      )
    })
  })

  return (
    <>
      {rendering}
    </>
  )
}
